<div class="msgs">
  <!-- feedback -->
  <feedback-card [message]="''" feedBackType="error" />
  <feedback-card [message]="''" feedBackType="success" />

  <!-- Search and filters -->
  <div class="msgs__toolbar">
    <app-search-input label="Search messages"
      class="msgs__search"
      placeholder="Search by subject"
      (valueChange)="updateSearchTerm($event)"
    />

    <app-status-filter
      [options]="statusOptions"
      [selectedValue]="statusSort"
      (selectionChange)="updateSortCriteria($any($event))"
    />

    <app-sort-dropdown
      [groups]="sortGroups"
      [selectedValue]="arrangementSort"
      (selectionChange)="updateSortArrangementCriteria($any($event))"
    />
  </div>

  <!-- Messages -->
  <div class="bk-panel msgs__panel">
    <data-table label="Inactive messages" [seamless]="true" [loading]="loading" [maxHeight]="'600px'" [skeletonColumns]="6">
      @if (rows.length > 0 || loading) {
        <table class="bk-log">
          <thead>
            <tr>
              <th scope="col">Message</th>
              <th scope="col" class="col-from">From</th>
              <th scope="col" class="col-status">Status</th>
              <th scope="col" class="col-delivery">Delivery</th>
              <th scope="col" class="col-when">Send time</th>
              <th scope="col" class="col-created">Created</th>
              <th scope="col" class="num col-parts">Parts</th>
              <th scope="col" class="col-actions"><span class="vh">Actions</span></th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row.key) {
              <tr class="is-link" (click)="goToMessageDetails(row.message)">
                <td class="col-msg">
                  <span class="bk-msg">
                    <a
                      class="bk-msg__subject"
                      [routerLink]="['/organization/messages', row.message.uuid]"
                      (click)="selectFromLink($event, row.message)"
                    >{{ row.subject }}</a>
                    <span class="bk-msg__preview">
                      @if (row.copy) {
                        <bk-sms-text [text]="row.copy" [inline]="true" />
                      } @else {
                        <span class="msgs__no-copy">No message text</span>
                      }
                    </span>
                  </span>
                </td>
                <td class="quiet col-from">{{ row.from }}</td>
                <td class="col-status">
                  <app-status [text]="row.message.status" [status]="row.message.status" />
                </td>
                <td class="col-delivery" [class.is-unsent]="!row.sent">
                  <bk-delivery
                    [uuid]="row.message.uuid"
                    [status]="row.message.status"
                    [sentAt]="row.message.sendAt || row.message.createdAt"
                  />
                </td>
                <td class="quiet col-when">{{ row.sendTime }}</td>
                <td class="quiet col-created">{{ row.created }}</td>
                <td class="num quiet col-parts" [attr.title]="row.partsHint">{{ row.parts }}</td>
                <td class="col-actions">
                  <span class="bk-row-actions">
                    <button
                      type="button"
                      class="bk-icon-btn"
                      aria-label="Edit draft"
                      [attr.aria-disabled]="row.status === 'draft' ? null : 'true'"
                      [matTooltip]="row.status === 'draft' ? 'Edit draft' : 'Only drafts can be edited'"
                      (click)="$event.stopPropagation(); editMessage(row.message)"
                    >
                      <span class="bk-sym" aria-hidden="true">edit</span>
                    </button>
                    <button
                      type="button"
                      class="bk-icon-btn"
                      aria-label="Delete"
                      matTooltip="Delete"
                      (click)="$event.stopPropagation(); openDeleteMessagePrompt(row.message)"
                    >
                      <span class="bk-sym" aria-hidden="true">delete</span>
                    </button>
                    <span class="bk-sym row-go" aria-hidden="true">chevron_right</span>
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <app-empty-state
          [icon]="searchTerm.trim() ? 'search' : 'messages'"
          [message]="emptyMessage"
          size="medium"
        />
      }
    </data-table>
  </div>

  <!-- Pagination -->
  <div class="msgs__pagination">
    <app-pagination
      (changePage)="updateMessagesPage($event)"
      [currentPage]="paginationData.pageNumber"
      [totalPages]="paginationData.totalPages"
      [loading]="loading"
      (pageSizeChange)="onPageSizeChange($event)"
    />
  </div>
</div>

<!-- MODALS -->

<!-- archive message -->
<app-prompt-card
  buttonText="archive"
  title="Archive this message?"
  [openModal]="showArchiveModal"
  (onClose)="closeArchiveModal()"
  (onButtonClick)="handleArchiveMessage()"
>
  <div class="description text-center">
    <span class="font-bold">{{ selectedMessage?.messageSubject }}</span> moves to Archived.
    You can move it back to active messages from there.
  </div>
</app-prompt-card>

<!-- cancel pending message -->
<app-prompt-card
  buttonText="cancel send"
  title="Cancel this scheduled send?"
  [openModal]="showCancelModal"
  (onClose)="closeCancelModal()"
  (onButtonClick)="handleCancelMessage()"
>
  <div class="description text-center">
    <span class="font-bold">{{ selectedMessage?.messageSubject }}</span> will not go out.
  </div>
</app-prompt-card>

<!-- delete message -->
<app-prompt-card
  buttonText="delete"
  title="Delete this message?"
  [openModal]="showDeleteModal"
  (onClose)="closeDeleteModal()"
  (onButtonClick)="handleDeleteMessage()"
>
  <div class="description text-center">
    <span class="font-bold">{{ selectedMessage?.messageSubject }}</span> is deleted.
    This cannot be undone.
  </div>
</app-prompt-card>
